import { render, staticRenderFns } from "./SimpleDataTable.vue?vue&type=template&id=7f07e07f&scoped=true"
import script from "./SimpleDataTable.vue?vue&type=script&lang=js"
export * from "./SimpleDataTable.vue?vue&type=script&lang=js"
import style0 from "./SimpleDataTable.vue?vue&type=style&index=0&id=7f07e07f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07e07f",
  null
  
)

export default component.exports